export default {
  title: 'Podsumowanie sprzedaży',
  description: 'Sprzedaż za wybrany okres — do rozliczeń z tą restauracją.',
  filters: {
    period: 'Okres',
  },
  presets: {
    this_month: 'Ten miesiąc',
    last_month: 'Poprzedni miesiąc',
    last_30_days: 'Ostatnie 30 dni',
    this_year: 'Ten rok',
  },
  fields: {
    orders_count: 'Zamówienia',
    net_sales: 'Sprzedaż netto',
    sales_tax: 'Podatek od sprzedaży',
    gross_sales: 'Sprzedaż brutto',
    delivery_fee_tax: 'Opłata za dostawę (podatek)',
    delivery_fee_gross: 'Opłata za dostawę (brutto)',
    tips_gross: 'Napiwki (brutto)',
    total: 'Łącznie',
  },
  kpi: {
    before_tax: 'przed opodatkowaniem',
    tips: 'zebrane dla restauracji',
    owed_to_restaurant: 'należne restauracji',
  },
  table: {
    title: 'Szczegółowe zestawienie',
    subtitle: '{{range}} · Wszystkie kwoty w {{currency}}',
    field: 'Pole',
    amount: 'Kwota',
    empty: 'Brak zamówień w wybranym okresie',
    footnote:
      'Sprzedaż netto nie zawiera podatku; sprzedaż brutto go uwzględnia · Łącznie jest kwotą po odliczeniu opłat platformy, więc nie jest tym, co zapłacił klient · Zwroty i obciążenia zwrotne są odliczane · Kwoty w {{currency}}',
  },
  buttons: {
    export_csv: 'Eksportuj CSV',
    refresh: 'Odśwież',
    retry: 'Spróbuj ponownie',
  },
  errors: {
    failed_to_load: {
      title: 'Nie udało się wczytać podsumowania sprzedaży',
      description: 'Wystąpił błąd podczas ładowania raportu. Spróbuj ponownie.',
    },
  },
};
